import { h } from "preact";
import { useCallback, useContext } from "preact/hooks";

export default function SuccessStep({ formContext }) {
  const { setCurrentStep, setFormData, formData } = useContext(formContext);
  const { address, accountNumber } = formData;

  const handleReset = useCallback(() => {
    setFormData({});
    setCurrentStep(0);
  }, [setFormData, setCurrentStep]);

  return (
    <div className="success-step">
      <div className="success-info">
        <p>{address}</p>
        <span>ЛС {accountNumber}</span>
      </div>
      <h1>Сохранено</h1>

      <p>Данные собственника жилого помещения успешно изменены!</p>

      <div style={{ marginTop: "50px" }}></div>

      <button
        className="button-secondary button-secondary_border-gray"
        onClick={handleReset}
      >
        Вернуться к адресам
      </button>

      <div className="payment-info">
        <div className="payment-info-text">
          <div className="payment-info-logo"></div>
          <p>Рекомендуем производить оплату с 23 по 26 число и использовать мобильное приложение <a href="https://платосфера.рф/?utm_source=NES&utm_medium=futer&utm_campaign=link" target="_blank">Платосфера</a> для передачи показаний и оплаты услуг.</p>
        </div>
        <div className="payment-info-qr"></div>
      </div>
    </div>
  );
}
